import { useTranslation } from 'next-i18next'
import React from 'react'

import Layouts from '@/layouts/Layouts'
import PressReleaseContent from '@/modules/media/press/PressReleaseContent'

import Banner from './Banner'

const PressRelease = () => {
  const { t } = useTranslation()
  return (
    <Layouts
      title={t('press:title')}
      description={t('press:description')}
    >
      <div className='w-full bg-white pt-14 lg:pt-18'>
        <Banner />
        <PressReleaseContent />
      </div>
    </Layouts>
  )
}

export default PressRelease
